export class WarningError extends Error {
  constructor(mensaje: string) {
    super(mensaje);
    Object.setPrototypeOf(this, new.target.prototype); // para herencia correcta en TS
  }
}

export class DangerError extends Error {
  constructor(mensaje: string) {
    super(mensaje);
    Object.setPrototypeOf(this, new.target.prototype); // para herencia correcta en TS
  }
}